// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getAlbums = createAsyncThunk(
	"userpanel/getAlbums",
	createApiCall(async (props, client, getState) => {
		const currentState = getState();
		const userId = currentState.globalUser.id;
		const addEmpty = props?.addEmpty;

		const response = await client.get(`/album/all`, {
			params: { user: userId, addEmpty: addEmpty ?? true },
		});

		return {
			data: response.data,
			counters: response.counters,
		};
	})
);

// ############################################################
